import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="mt-16 border-t border-background-200 bg-background-100">
      <div className="mx-auto max-w-[1440px] px-4 py-12 md:px-8">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="fa-solid fa-spade text-[18px]" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-xl font-600 text-foreground-950">黑桃视频</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
              黑桃视频专注最新影视资讯与热门影视频道推荐，为电影剧迷与影视爱好者提供专业、实用且内容丰富的影视内容聚合服务。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-600 uppercase tracking-wider text-foreground-800">
              快速导航
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li><Link to="/" className="text-foreground-600 transition-colors hover:text-primary-500">首页</Link></li>
              <li><Link to="/category" className="text-foreground-600 transition-colors hover:text-primary-500">影视分类</Link></li>
              <li><Link to="/channel" className="text-foreground-600 transition-colors hover:text-primary-500">频道推荐</Link></li>
              <li><Link to="/search" className="text-foreground-600 transition-colors hover:text-primary-500">搜索影视</Link></li>
              <li><Link to="/about" className="text-foreground-600 transition-colors hover:text-primary-500">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-600 uppercase tracking-wider text-foreground-800">
              影视分类
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li><Link to="/category?category=电影" className="text-foreground-600 transition-colors hover:text-primary-500">电影</Link></li>
              <li><Link to="/category?category=电视剧" className="text-foreground-600 transition-colors hover:text-primary-500">电视剧</Link></li>
              <li><Link to="/category?category=综艺" className="text-foreground-600 transition-colors hover:text-primary-500">综艺</Link></li>
              <li><Link to="/category?category=纪录片" className="text-foreground-600 transition-colors hover:text-primary-500">纪录片</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-200 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 黑桃视频 Heitao Video. 本站所有影视资讯与内容均为虚构演示数据，仅供结构展示使用。</p>
          <p className="whitespace-nowrap">仅供演示 · 不提供播放与下载</p>
        </div>
      </div>
    </footer>
  );
}